var map = {
	"./asg.js": "0508",
	"./bsg.js": "8cde",
	"./demo.js": "2a7b",
	"./home.js": "8fe8",
	"./index.js": "a18c",
	"./product.js": "824d",
	"./prospect.js": "da9f",
	"./sample.js": "1e01",
	"./switch.js": "9ad5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e5a";